import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType, GasoilConsumptionPriceSource } from "__generated__/graphql";
import GasoilConsumptionCalculationMethodForm from "view/calculationmethods/components/form/GasoilConsumptionCalculationMethodForm";
import GasoilConsumptionCalculationMethodDetails from "view/calculationmethods/components/details/GasoilConsumptionCalculationMethodDetails";

export const GasoilConsumptionSchema: RegistryItem = {
	[CalculationMethodType.GasoilConsumption]: {
		Form: GasoilConsumptionCalculationMethodForm,
		Details: GasoilConsumptionCalculationMethodDetails,
		fields: {
			"calculationMethod.priceSource": {
				path: "priceSource",
				rules: {
					required: true,
					hidden: true,
				},
			},
			"calculationMethod.price": {
				path: "price",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.priceSource === GasoilConsumptionPriceSource.Manual,
				},
			},
			"calculationMethod.referenceRateDateType": {
				path: "referenceRateDateType",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.priceSource === GasoilConsumptionPriceSource.Kbn,
				},
			},
		},
		toInput: (form) => ({
			gasoilConsumptionCalculationMethodInput: {
				id: form.id,
				priceSource: form.priceSource,
				referenceRateDateType: form.referenceRateDateType,
				price: form.price,
			},
		}),
		toForm: (method) => ({
			priceSource: method.priceSource ?? undefined,
			referenceRateDateType: method.referenceRateDateType ?? undefined,
		}),
	},
};
